var React = require('react');

function ServicesIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Icon"},[React.createElement("path",{"d":"M32.042 10.75 18.98 23.813l-6.88-6.875L1.792 27.25","transform":"translate(.072 -2.5)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":0}),React.createElement("path",{"data-name":"Path","d":"M30.458 10.75h8.25V19","transform":"translate(-6.594 -2.5)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":1})]));
}

ServicesIcon.defaultProps = {"width":"33.527","height":"33","viewBox":"0 0 33.527 33"};

module.exports = ServicesIcon;

ServicesIcon.default = ServicesIcon;
